// src/components/HeaderBar.js
import React, { useState, useEffect } from "react";
import { Layout, Typography, Avatar, Button, Modal } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;
const { Title } = Typography;

const HeaderBar = ({ title = "Dashboard" }) => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <>
      {/* Header */}
      <Header className="dashboard-header">
        <div className="header-left">
          <Title level={3} className="header-title">{title}</Title>
        </div>

        <div className="header-right">
          <h4 className="header-username">Welcome, {user?.username}</h4>
      <div
  onClick={() => setIsModalVisible(true)}
  style={{
    width: 45,
    height: 45,
    borderRadius: "50%",
    overflow: "hidden",     // 👈 prevents image from going outside
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <img
    src={user?.logo}
    alt="logo"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",   // 👈 fills the circle perfectly
    }}
  />
</div>


        </div>
      </Header>

      {/* User Modal */}
      <Modal
        title="User Account"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button
            key="logout"
            type="primary"
            danger
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          >
            Sign Out
          </Button>,
        ]}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <Avatar
            size={64}
            src={user?.logo || null}
             style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",   // 👈 fills the circle perfectly
    }}
            icon={!user?.logo && <UserOutlined />}
          />
          <div>
            <Title level={5}>{user?.username || "User"}</Title>
            <p>Email: {user?.email || "No email"}</p>
            <p>Company: {user?.company_name || "No company"}</p>
          </div>
        </div>
      </Modal>

      {/* Styles */}
      <style>{`
        .dashboard-header {
          background: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 16px;
        }
        .header-left {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .header-title {
          margin: 0 !important;
        }
        .header-right {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .header-username {
          margin: 0;
        }
        @media (max-width: 768px) {
          .header-title {
            font-size: 18px !important;
          }
          .header-username {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

export default HeaderBar;
